<template>
  <label class="app-form-comment">
    <slot />

    <p class="app-form-comment__text" v-html="value"></p>
  </label>
</template>

<script>
export default {
  name: 'AppFormComment',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss">
.app-form-comment {
  display: block;

  &__text {
    a {
      color: inherit;
    }

    strong {
      font-weight: 900;
      color: #ff0000;
    }
  }
}
</style>
